import type React from 'react';

import LogoText from '@/assets/code-flicker-black.svg';
import { PRODUCT_NAME } from '@/shared/constance';

type FormLayoutProps = {
  children: React.ReactNode;
  title: string;
};

export const FormLayout = ({ children, title }: FormLayoutProps) => {
  return (
    <div className="flex flex-1 items-center justify-center bg-[#F6F6F6] px-4 lg:w-[729px]">
      <div className="flex w-full max-w-[581px] flex-col items-center gap-[36px]">
        {/* 移动端Logo */}
        <div className="hidden w-full justify-center">
          <img src={LogoText} alt={PRODUCT_NAME} className="h-8" />
        </div>

        {/* 标题 */}
        <div className="flex w-full flex-col items-center gap-[12px]">
          <h1 className="text-center text-[48px] font-bold leading-[150%] text-[#23343E]">
            {title}
          </h1>
        </div>

        {/* 表单内容 */}
        <div className="flex w-full max-w-[375px] flex-col gap-[2px]">{children}</div>
      </div>
    </div>
  );
};
